import React, { useContext } from "react";
import StudentPaperLogo from "../../assets/images/edsiderlogo.png";
import { QuestionMetaContext } from "../../context/assessSections/QuestionMetaContext";

function formatDuration(assessment) {
  if (!assessment) return "Unlimited";
  if (
    assessment.is_set_time_limit === false ||
    assessment.is_set_time_limit === 0
  ) {
    return "Unlimited";
  }

  const interval = assessment.exam_time_interval;
  const unit = assessment.exam_time_interval_unit_id;

  if (!interval) return "Unlimited";

  const unitLabel =
    Number(unit) === 1 ? "min" :
      Number(unit) === 2 ? "hr" :
        Number(unit) === 3 ? "day" :
          "min";

  return `${interval} ${unitLabel}`;
}

function formatStartTime(value) {
  if (!value) return "N/A";

  try {
    const text = String(value).trim();

    const date =
      text.endsWith("Z") || /[+-]\d{2}:\d{2}$/.test(text)
        ? new Date(text)
        : new Date(`${text}Z`);

    if (Number.isNaN(date.getTime())) return value;

    return date.toLocaleString(undefined, {
      dateStyle: "medium",
      timeStyle: "short",
    });
  } catch {
    return value;
  }
}

function formatGrade(value) {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  const gradeText = String(value);

  if (gradeText.toLowerCase().includes("grade")) {
    return gradeText;
  }

  return `Grade ${gradeText}`;
}

export default function StudentPaperHeader({
  assessment,
  title,
  subtitle,
  showStartTime = true,
}) {
  const questionMeta = useContext(QuestionMetaContext);

  const details = assessment?.assessment_details || {};

  const paperTitle = title || details.title || "Assessment";

  const gradeValue = details.grade;

  const gradeLabel = formatGrade(
    questionMeta?.getGradeName?.(gradeValue) || `0${gradeValue}`.slice(-2)
  );

  const subjectLabel = details.subject || null;

  const mediumValue = details.medium;

  const languageLabel = (() => {
    if (!mediumValue) return null;

    const resolvedMedium =
      questionMeta?.getLanguageName?.(mediumValue) || mediumValue;

    if (String(resolvedMedium).toLowerCase().includes("medium")) {
      return resolvedMedium;
    }

    return `${resolvedMedium} Medium`;
  })();

  const duration = formatDuration({
    is_set_time_limit:
      assessment?.is_set_time_limit ??
      assessment?.validation?.is_set_time_limit,

    exam_time_interval:
      assessment?.exam_time_interval ??
      assessment?.validation?.exam_time_interval ??
      assessment?.exam_duration,

    exam_time_interval_unit_id:
      assessment?.exam_time_interval_unit_id ??
      assessment?.validation?.exam_time_interval_unit_id,
  });

  const owner = details.author || "";

  const startTime = formatStartTime(
    assessment.attempt_start_time || assessment.start_time
  );

  return (
    <div className="student-paper-header row g-0">
      <div className="student-paper-brand col-12 col-md-auto">
        <img
          src={StudentPaperLogo}
          alt="EdFoci logo"
          className="student-paper-logo"
        />
      </div>

      <div className="student-paper-heading col-12 col-md">
        <h1>
          {[gradeLabel, subjectLabel, paperTitle].filter(Boolean).join(" — ")}
        </h1>

        {subtitle && <p>{subtitle}</p>}

        <div className="student-paper-line" />

        <div className="student-paper-meta">
          {languageLabel && <span>{languageLabel}</span>}
          {subjectLabel && <span>{subjectLabel}</span>}
          <span>Duration: {duration}</span>
          {showStartTime && <span>Attempted Time: {startTime}</span>}
          {owner && <span>Provided by: {owner}</span>}
        </div>
      </div>
    </div>
  );
}
